<po-page-default
  p-title="Modulo Entrada de NFs"
  [p-actions]="pageActions">

  <div class="po-row">

    <!-- Coluna principal -->
    <div class="po-md-8">

      <!-- DOCUMENTO -->
      <po-widget p-title="Documento">
        <div class="po-row">
          <po-info class="po-md-2" p-label="Tipo" [p-value]="nota.tipo" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="Série" [p-value]="nota.serie || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="Número" [p-value]="'' + numeroExibe" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="Data Emissão" [p-value]="formatEmissao(nota.emissao)" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="Serviço" [p-value]="nota.servico" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <div class="po-md-2">
            <span class="po-font-text-small po-font-text-bold">Origem</span><br>
            <po-tag p-value="Transmite" p-color="color-11"></po-tag>
          </div>
        </div>
      </po-widget>

      <!-- EMISSOR -->
      <po-widget p-title="Emissor" class="po-mt-2">
        <div class="po-row">
          <po-info class="po-md-8" p-label="Razão Social" [p-value]="nota.emissor.razaoSocial || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-4" p-label="Nome Fantasia" [p-value]="nota.emissor.nomeFantasia || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <po-divider></po-divider>
        <div class="po-row">
          <po-info class="po-md-6" p-label="Endereço" [p-value]="nota.emissor.endereco" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Município" [p-value]="nota.emissor.municipio" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="CEP" [p-value]="nota.emissor.cep" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <div class="po-row po-mt-1">
          <po-info class="po-md-3" p-label="CNPJ" [p-value]="nota.emissor.cnpj || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Bairro" [p-value]="nota.emissor.bairro || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="País" [p-value]="nota.emissor.pais || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Complemento" [p-value]="nota.emissor.complemento || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
      </po-widget>

      <!-- TOMADOR -->
      <po-widget p-title="Tomador" class="po-mt-2">
        <div class="po-row">
          <po-info class="po-md-8" p-label="Razão Social" [p-value]="nota.tomador.razaoSocial || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-4" p-label="Nome Fantasia" [p-value]="nota.tomador.nomeFantasia || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <po-divider></po-divider>
        <div class="po-row">
          <po-info class="po-md-6" p-label="Endereço" [p-value]="nota.tomador.endereco || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Município" [p-value]="nota.tomador.municipio" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="CEP" [p-value]="nota.tomador.cep || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <div class="po-row po-mt-1">
          <po-info class="po-md-3" p-label="CNPJ" [p-value]="nota.tomador.cnpj || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Bairro" [p-value]="nota.tomador.bairro || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="País" [p-value]="nota.tomador.pais || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Complemento" [p-value]="nota.tomador.complemento || '-'" [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
      </po-widget>

      <!-- IMPOSTOS -->
      <po-widget p-title="Informações de Prestação de Serviço" class="po-mt-2">
        <div class="po-row">
          <po-info class="po-md-2" p-label="PIS" [p-value]="(nota.impostos.pis | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="COFINS" [p-value]="(nota.impostos.cofins | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="IR" [p-value]="(nota.impostos.ir | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="INSS" [p-value]="(nota.impostos.inss | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="CSLL" [p-value]="(nota.impostos.csll | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-2" p-label="Total" [p-value]="(nota.impostos.total | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          @if (valorPedagio > 0) {
            <po-info class="po-md-2" p-label="Pedágio" [p-value]="(valorPedagio | currency: 'BRL':'symbol':'1.2-2') ?? ''" [p-orientation]="poInfoOrientation.Vertical"></po-info>
          }
        </div>
      </po-widget>

      <!-- OBSERVACOES -->
      <po-widget p-title="Observações" class="po-mt-2">
        <p>{{ nota.observacoes }}</p>
      </po-widget>

      <!-- OBSERVACOES ADICIONAIS -->
      <po-widget p-title="Observações Adicionais" class="po-mt-2">
        <p>{{ nota.observacoesAdicionais || '-' }}</p>
      </po-widget>

    </div>

    <!-- Sidebar -->
    <div class="po-md-4">

      <!-- FORMULARIO -->
      <po-widget [p-title]="isReadonly ? 'Formulario (somente leitura)' : 'Formulario'">
        <!-- Fluxo NORMAL: Processo + Tipo de Operacao.
             Fornecedor oculto nao usa processo (Image 13) - dispensa esses
             campos e mostra Conta Contabil/BU/CC abaixo. -->
        <po-input
          *ngIf="!fornecedorOculto"
          p-label="Processo"
          [ngModel]="processo"
          (p-change)="onProcessoChange($event)"
          [p-disabled]="(isReadonly || semProcesso === 'sim') ? 'true' : 'false'"
          name="processo">
        </po-input>

        <!-- Radio "Sem processo": aparece quando o BACKEND liberou a nota
             (podeSemProcesso = privilegio SEMPROC no menu /notas-list OU CTe
             de tomador DAAS, regra 2026-05-27). Quando = Sim, o campo
             Processo eh desabilitado e o payload leva semProcesso=true. Em
             CTe da DAAS o backend forca TES 403 + natureza 293014; nas demais
             especies a TES vem daqui e e obrigatoria. Chamado 00017826. -->
        <po-radio-group
          *ngIf="!fornecedorOculto && podeSemProcesso"
          p-label="Sem processo"
          [ngModel]="semProcesso"
          (p-change)="onSemProcessoChange($event)"
          [p-options]="semProcessoOptions"
          [p-disabled]="isReadonly"
          name="semProcesso">
        </po-radio-group>

        <po-radio-group
          p-label="Gera Financeiro"
          [ngModel]="geraFinanceiro"
          (p-change)="onGeraFinanceiroChange($event)"
          [p-options]="geraFinanceiroOptions"
          [p-disabled]="isReadonly"
          name="geraFinanceiro">
        </po-radio-group>

        <!-- So' trava a TES no caminho CTe + tomador DAAS, onde o backend
             forca a 403. Nas demais especies o backend EXIGE a TES enviada
             pelo front: travar o campo aqui inviabilizaria a entrega.
             Na Logistica (005003) a TES depende da finalidade do frete e o
             operador escolhe - chamado 00018371. -->
        <po-select
          *ngIf="!fornecedorOculto"
          p-label="Tipo de Operação"
          [ngModel]="tipoOperacao"
          (p-change)="onTipoOperacaoChange($event)"
          [p-options]="tipoOperacaoOptions"
          [p-disabled]="(isReadonly
                         || (isCte && tomadorDaas && semProcesso === 'sim')
                         ) ? 'true' : 'false'"
          name="tipoOperacao">
        </po-select>

        <!-- Fluxo OCULTO: Conta Contabil + BU + Centro de Custo (Image 13).
             A TES eh decidida no backend (333/305/300 conforme issRet/Hubsul). -->
        <po-select
          *ngIf="fornecedorOculto"
          p-label="Conta Contábil"
          [ngModel]="contaContabil"
          (p-change)="onContaContabilChange($event)"
          [p-options]="ocultoContaOptions"
          [p-disabled]="isReadonly ? 'true' : 'false'"
          name="contaContabil">
        </po-select>

        <po-select
          *ngIf="fornecedorOculto"
          p-label="BU"
          [ngModel]="bu"
          (p-change)="bu = $event"
          [p-options]="ocultoBuOptions"
          [p-disabled]="isReadonly ? 'true' : 'false'"
          name="bu">
        </po-select>

        <po-select
          *ngIf="fornecedorOculto"
          p-label="Centro de Custo"
          [ngModel]="centroCusto"
          (p-change)="centroCusto = $event"
          [p-options]="ocultoCcOptions"
          [p-disabled]="isReadonly ? 'true' : 'false'"
          name="centroCusto">
        </po-select>

        <!-- Produto: troca a lista conforme o fluxo (cascata em oculto,
             CNAE em normal). O .ts mantem produtoOptionsAtivo retornando
             a fonte correta. -->
        <po-select
          p-label="Produto"
          [ngModel]="produto"
          (p-change)="produto = $event"
          [p-options]="produtoOptionsAtivo"
          [p-disabled]="(isReadonly || (fornecedorOculto && !contaContabil)) ? 'true' : 'false'"
          name="produto">
        </po-select>

        <po-datepicker
          p-label="Vencimento"
          p-placeholder="dd/mm/aaaa"
          p-format="dd/mm/yyyy"
          [(ngModel)]="vencimento"
          [p-disabled]="(isReadonly || geraFinanceiro !== 'sim') ? 'true' : 'false'"
          name="vencimento">
        </po-datepicker>

        <po-textarea
          p-label="Comentário"
          [ngModel]="comentario"
          (p-change)="comentario = $event"
          [p-disabled]="isReadonly"
          name="comentario">
        </po-textarea>

        <div class="po-row po-mt-2" *ngIf="!isReadonly">
          <po-button class="po-mr-1" p-kind="primary" p-label="Aprovar" p-icon="an an-check-circle" p-small
                     (p-click)="onAprovar()" [p-loading]="aprovando" [p-disabled]="aprovando || reprovando"></po-button>
          <po-button p-kind="secondary" p-label="Reprovar" p-icon="an an-x-circle" p-small p-danger
                     (p-click)="abrirReprovar()" [p-disabled]="aprovando || reprovando"></po-button>
        </div>
      </po-widget>

      <!-- ANEXOS -->
      <po-widget p-title="Anexos" class="po-mt-2">
        <div class="po-row po-mb-1" *ngIf="!isReadonly">
          <div class="po-md-12">
            <po-button
              p-kind="secondary"
              p-label="Adicionar"
              p-icon="an an-paperclip"
              p-small
              (p-click)="abrirUpload()">
            </po-button>
          </div>
        </div>

        <!-- Pendentes (selecionados pelo usuario, ainda nao enviados).
             Sao submetidos automaticamente apos clicar em Aprovar. -->
        <div *ngIf="pendingAnexos.length > 0" class="po-mt-2 po-mb-2">
          <div class="po-font-text-small po-font-text-bold po-mb-1">
            A enviar na aprovacao ({{ pendingAnexos.length }})
          </div>
          <po-table
            [p-columns]="pendingAnexosColumns"
            [p-items]="pendingAnexos"
            [p-actions]="pendingAnexosActions"
            [p-hide-columns-manager]="true"
            [p-show-more-disabled]="true"
            [p-striped]="true">
          </po-table>
        </div>

        <po-loading-overlay *ngIf="loadingAnexos" p-text="Carregando anexos..."></po-loading-overlay>

        <po-table
          [p-columns]="anexosColumns"
          [p-items]="anexos"
          [p-actions]="anexosActions"
          [p-hide-columns-manager]="true"
          [p-show-more-disabled]="true"
          [p-loading]="loadingAnexos"
          [p-striped]="true">
        </po-table>
      </po-widget>

      <!-- INTEGRACAO COM O CONEXOS -->
      <po-widget *ngIf="cnxIntegracao" p-title="Integração com o Conexos" class="po-mt-2">
        <div class="po-row">
          <po-info class="po-md-3" p-label="Situação"
            [p-value]="cnxIntegracao.statusDes || '-'"
            [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Documento no Conexos"
            [p-value]="cnxIntegracao.documento || '-'"
            [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Última tentativa"
            [p-value]="cnxUltimaTentativa"
            [p-orientation]="poInfoOrientation.Vertical"></po-info>
          <po-info class="po-md-3" p-label="Tentativas"
            [p-value]="'' + cnxIntegracao.tentativas"
            [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <div class="po-row" *ngIf="cnxIntegracao.mensagem">
          <po-info class="po-md-12" p-label="Último retorno"
            [p-value]="cnxIntegracao.mensagem || ''"
            [p-orientation]="poInfoOrientation.Vertical"></po-info>
        </div>
        <p class="po-font-text-small po-mt-1" *ngIf="cnxIntegracao.podeReproc">
          O reenvio manual fica na tela de Notas Entregues, na ação "Reprocessar no Conexos".
        </p>
      </po-widget>

      <!-- HISTORICO -->
      <po-widget p-title="Histórico" class="po-mt-2">
        <po-table
          [p-columns]="historicoColumns"
          [p-items]="nota.historico"
          [p-hide-columns-manager]="true"
          [p-show-more-disabled]="true">
        </po-table>
      </po-widget>

    </div>

  </div>

</po-page-default>

<po-modal
  #uploadModal
  p-title="Adicionar anexo"
  [p-primary-action]="modalUploadPrimary"
  [p-secondary-action]="modalUploadSecondary">

  <po-loading-overlay *ngIf="uploadingAnexo" p-text="Enviando..."></po-loading-overlay>

  <div class="po-row">
    <po-select
      class="po-md-12"
      p-label="Pasta GED"
      [ngModel]="gedFolderSelected"
      (p-change)="gedFolderSelected = $event"
      [p-options]="gedFolderOptions"
      name="gedFolder">
    </po-select>
  </div>

  <div class="po-row">
    <div class="po-md-12">
      <label class="po-font-text-small po-font-text-bold" style="display:block;margin-bottom:6px;">
        Arquivos (max 10 MB cada). O tipo eh definido individualmente por anexo.
      </label>
      <label class="anexo-modal-btn" [class.anexo-modal-btn--filled]="filesSelected.length > 0">
        <span class="po-icon an an-paperclip anexo-modal-btn__icon"></span>
        <span class="anexo-modal-btn__text">
          {{ filesSelected.length === 0
              ? 'Selecionar arquivos (PDF) - voce pode escolher varios de uma vez'
              : 'Adicionar mais arquivos (' + filesSelected.length + ' selecionado(s))' }}
        </span>
        <input
          type="file"
          accept=".pdf,application/pdf"
          multiple
          (change)="onFileSelected($event)"
          hidden>
      </label>

      <ul *ngIf="filesSelected.length > 0" class="anexo-modal-files">
        <li *ngFor="let entry of filesSelected; let idx = index">
          <po-select
            class="anexo-modal-files__tipo"
            p-placeholder="Tipo"
            [ngModel]="entry.tipo"
            (p-change)="entry.tipo = $event"
            [p-options]="tipoOptions"
            [attr.name]="'tipo_' + idx"
            p-required>
          </po-select>
          <span class="anexo-modal-files__name" [title]="entry.file.name">{{ entry.file.name }}</span>
          <button
            type="button"
            class="anexo-modal-files__remove"
            (click)="removerArquivoSelecionado(idx)"
            title="Remover este arquivo">
            x
          </button>
        </li>
      </ul>

      <a *ngIf="filesSelected.length > 1" class="anexo-modal-clear" (click)="clearFileSelected()">Remover todos</a>
    </div>
  </div>

</po-modal>

<po-modal
  #reprovarModal
  p-title="Reprovar pré-nota"
  [p-primary-action]="modalReprovarConfirma"
  [p-secondary-action]="modalReprovarCancela">

  <po-loading-overlay *ngIf="reprovando" p-text="Excluindo..."></po-loading-overlay>

  <p class="po-font-text">
    Tem certeza que deseja reprovar a pré-nota
    <strong>{{ numeroExibe }}</strong>?
  </p>
  <p class="po-font-text-small" style="color: #c0392b; margin-top: 8px;">
    Esta ação exclui SDS + SDT + CKO (staging do Arquivei).
    Não poderá ser desfeita pelo portal.
  </p>

  <div class="po-row" style="margin-top: 16px;">
    <po-input
      class="po-md-12"
      p-label="Motivo da reprovação"
      [(ngModel)]="motivoReprovacao"
      [ngModelOptions]="{standalone: true}"
      [p-maxlength]="200"
      p-placeholder="Ex: divergência de valor, fornecedor errado, etc.">
    </po-input>
  </div>
</po-modal>
